import type { FC, LegacyRef } from 'react';
import { forwardRef } from 'react';

export const withRef = <T, P = {}>(render: FC<P & { ref?: LegacyRef<T> | undefined }>) =>
  Object.assign(
    forwardRef<T, P>((props, ref) => render({ ...props, ref })),
    render
  );
